<template>
  <div class="result-wrap text-center">
      <p class="order-title">
        <b>{{ $t('order.noOrders') }}</b>
      </p>
      <img class="order-icon" src="./imgs/order-icon.svg">
      <p>
        {{ $t('order.noOrdersTip') }}
      </p>

      <div class="actions">
        <h-button size="large" type="primary" @click="action">{{ $t('order.noOrderAction') }}</h-button>
      </div>
  </div>
</template>

<style type="text/css" scoped>

.result-wrap {
  background-color: #fff;
  overflow: hidden;
  color: #000;
  padding-top: 110px;
  padding-bottom: 80px;
}

.order-title {
  font-size: 18px;
}

.actions {
  margin: 50px auto;
  width: 197px;
}

.order-icon {
  margin: 45px 0;
}
</style>

<script type="text/javascript">
import { Button as hButton } from 'hsb_recycle_components';

export default {
  components: {
    hButton
  },
  methods: {
    action () {
      this.$emit('action');
    }
  }
};
</script>
